import NotificationManager from 'react-notifications/lib/NotificationManager';
import balancesActionTypes from '../actionTypes/balancesActionTypes';
import {
  getUserBalancesApi,
  getBillingDataApi,
  getWithdrawApi,
  getTokensListApi,
  // eslint-disable-next-line import/named
  getTransactionsHistoryApi, confirmWithdrawApi,
} from '../../api/apiUrls/balances';
import authActions from './authActions';
import helpers from '../../helpers/helpers';

const getUserBalancesStart = () => ({ type: balancesActionTypes.GET_USER_BALANCES_START });
const getUserBalancesSuccess = (payload) => ({
  type: balancesActionTypes.GET_USER_BALANCES_SUCCESS,
  payload,
});
const getUserBalancesFailure = (payload) => ({
  type: balancesActionTypes.GET_USER_BALANCES_FAIL,
  payload,
});

const getUserBalances = (token) => (dispatch) => {
  dispatch(getUserBalancesStart());
  getUserBalancesApi(token)
    .then((res) => {
      dispatch(getUserBalancesSuccess(res.data));
      if (res?.data?.data?.user) {
        dispatch(authActions.saveUserData(res.data.data.user));
      }
    })
    .catch((e) => {
      dispatch(getUserBalancesFailure(e.response?.status));
    });
};

// eslint-disable-next-line max-len
const getTransactionHistoryStart = () => ({ type: balancesActionTypes.GET_TRANSACTIONS_HISTORY_START });
const getTransactionHistorySuccess = (payload) => ({
  type: balancesActionTypes.GET_TRANSACTIONS_HISTORY_SUCCESS,
  payload,
});
const getTransactionHistoryFailure = (payload) => ({
  type: balancesActionTypes.GET_TRANSACTIONS_HISTORY_FAIL,
  payload,
});

const getTransactionHistory = (token) => (dispatch) => {
  dispatch(getTransactionHistoryStart());
  getTransactionsHistoryApi(token)
    .then((res) => {
      dispatch(getTransactionHistorySuccess(res.data.data));
    })
    .catch((e) => {
      dispatch(getTransactionHistoryFailure(e.response?.status));
    });
};

const getDepositDataStart = () => ({ type: balancesActionTypes.GET_DEPOSIT_DATA_START });
const getDepositDataSuccess = (payload) => ({
  type: balancesActionTypes.GET_DEPOSIT_DATA_SUCCESS,
  payload,
});
const getDepositDataFailure = (payload) => ({
  type: balancesActionTypes.GET_DEPOSIT_DATA_FAIL,
  payload,
});

const getDepositData = (token, id) => (dispatch) => {
  dispatch(getDepositDataStart());
  getBillingDataApi(token, id)
    .then((res) => {
      dispatch(getDepositDataSuccess(res.data.data));
    })
    .catch((e) => {
      dispatch(getDepositDataFailure(e.response.status));
    });
};

const getTokensListStart = () => ({ type: balancesActionTypes.GET_TOKENS_LIST_START });
const getTokensListSuccess = (payload) => ({
  type: balancesActionTypes.GET_TOKENS_LIST_SUCCESS,
  payload,
});
const getTokensListFailure = (payload) => ({
  type: balancesActionTypes.GET_TOKENS_LIST_FAIL,
  payload,
});

const getTokensListBySearchValueStart = () => ({ type: balancesActionTypes.GET_TOKENS_LIST_BY_SEARCH_VALUE_START });
const getTokensListBySearchValueEnd = () => ({ type: balancesActionTypes.GET_TOKENS_LIST_BY_SEARCH_VALUE_END });

const getTokensList = (token) => (dispatch) => {
  dispatch(getTokensListStart());
  getTokensListApi(token)
    .then((res) => {
      dispatch(getTokensListSuccess(res.data.data));
    })
    .catch((e) => {
      dispatch(getTokensListFailure(e.response));
    });
};

const getTokensListBySearchValue = (token, searchValue, page = 1) => (dispatch) => {
  dispatch(getTokensListBySearchValueStart());
  return getTokensListApi(token, searchValue, page)
    .then((res) => {
      dispatch(getTokensListBySearchValueEnd());
      return res.data;
    })
    .catch((e) => {
      dispatch(getTokensListBySearchValueEnd());
      return e;
    });
};

const getWithdrawStart = () => ({ type: balancesActionTypes.GET_WITHDRAW_START });
const getWithdrawSuccess = (payload) => ({
  type: balancesActionTypes.GET_WITHDRAW_SUCCESS,
  payload,
});
const getWithdrawFailure = (payload) => ({
  type: balancesActionTypes.GET_WITHDRAW_FAIL,
  payload,
});

const getWithdraw = (token, data) => (dispatch) => {
  dispatch(getWithdrawStart());
  return getWithdrawApi(token, data)
    .then((res) => {
      NotificationManager.success(helpers.getTranslationText('withdraw.create_success') || 'Withdraw created');
      dispatch(getWithdrawSuccess());
      return res;
    })
    .catch((e) => {
      dispatch(getWithdrawFailure(e.response));
      return e;
    });
};

const confirmWithdraw = (token, id, code) => (dispatch) => {
  return confirmWithdrawApi(token, id, code)
    .then((res) => {
      if (res.data.success) {
        NotificationManager.success(helpers.getTranslationText('withdraw.confirm_success') || 'Withdraw confirmed');
        dispatch(balancesActions.getTransactionHistory(token));
      }
      return res;
    })
    .catch((e) => {
      return e;
    });
};

const balancesActions = {
  getUserBalances,
  getDepositData,
  getTokensList,
  getTokensListBySearchValue,
  getWithdraw,
  getTransactionHistory,
  getWithdrawFailure,
  confirmWithdraw,
};

export default balancesActions;
